import { getDatabase, set, ref } from 'firebase/database';

const db = getDatabase();

export async function setNewUser(userId, userData) {
    const reference = ref(db, 'users/' + userId);

    return set(reference, userData);
}